import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import css from './NextEvent.module.scss'
import { giornoEvento } from '../../../../services/community'

// Il prossimo evento della community: porta alla pagina Eventi del sito
const NextEvent = ({ events }) => {
  if ((events.list || []).length === 0) {
    return null
  }

  const e = events.list[0]
  return (
    <div className={css.NextEvent}>
      <Link to='/eventi' className={css.Link}>
        <i className='fa-solid fa-calendar-day'></i>
        {giornoEvento(e)} &bull; {e.title}
      </Link>
    </div>
  )
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {})(NextEvent)
